import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import MysticalParticles from './MysticalParticles';

const NewbieGuidePage = () => {
  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Magical Background */}
      <div className="fixed inset-0 -z-10">
        <img 
          src="https://cdn.4fingerstudios.com/Mystveil/Mystveil_map.png" 
          alt="Mystveil Township Map" 
          className="w-full h-full object-cover opacity-30 blur-sm" 
        />
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-pink-900/20 to-purple-900/20"></div>
      </div>

      {/* Magical Particles */}
      <MysticalParticles />

      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="mystical-card">
            <h1 className="mystical-title text-black mb-8">
              Newbie Guide
            </h1>

            <div className="space-y-8">
              {/* What is Mystveil Township */}
              <div className="mystical-card bg-white bg-opacity-95">
                <h2 className="mystical-subtitle text-black text-2xl mb-6 pb-2 border-b-2 border-purple-500 border-opacity-30">
                  What is Mystveil Township?
                </h2>
                <div className="space-y-4">
                  <p className="mystical-text text-gray-800 text-lg leading-relaxed">
                    Mystveil Township is a video game in development, created by Opossol and MURD3RMYS3RY in collaboration with 4 Finger Studios. It is heavily inspired by Evolution Art Roleplaying Games hosted on deviantart. It takes place in a world known as The Shifting Lands. The Shifting Lands is filled with magic, its only pieces of land floating up high in the sky while the more unknown forces lay below in the ruins. Nothing stays the same in The Shifting Lands, not even Veilkin themselves!
                  </p>
                  <p className="mystical-text text-black leading-relaxed">
                    The dragons who live in The Shifting Lands, known as Veilkin, end up changing their shape to fit their environment and their needs. The more experienced they are, the larger and more unique they become.
                  </p>
                  <p className="mystical-text text-black leading-relaxed">
                    Mystveil Township's ARPG is meant to be a beta testing environment for the larger game, and will host a limited amount of slots of members. While not all concepts from the ARPG will be in the video game, it will be close enough to what we desire to be!
                  </p>
                  <p className="mystical-text text-black leading-relaxed font-bold">
                    All beta testers/members must be 16 years old or older due to comfort of the dev team and future storytelling meant for older audiences.
                  </p>
                </div>
              </div>

              {/* What is an ARPG */}
              <div className="mystical-card">
                <h2 className="mystical-subtitle text-black text-2xl mb-6">
                  What is an ARPG [Art Roleplaying Game]?
                </h2>
                <p className="mystical-text text-black leading-relaxed">
                  ARPG is short for Art Roleplaying Game. An Art Roleplaying Game is a world building project created by one or more artists, in which aspects of its world are played similarly to a Life Simulation game. However instead of limited choices which the game provides by default, you, the artist, have the option to create the character yourselves in a more personal manner and have them interact with the world the way you want to. Draw your character, interact with other member's characters, and have them react to events in your own way! You, as the player and creator/owner of your character, pick how things are done!
                </p>
              </div>

              {/* What is a MYO */}
              <div className="mystical-card">
                <h2 className="mystical-subtitle text-black text-2xl mb-6">
                  What is a MYO [Make Your Own]?
                </h2>
                <p className="mystical-text text-black leading-relaxed">
                  MYO stands for Make your own, meaning you design your new character! Within Mystveil, you will be designing a Hatchling to play the Mystveil ARPG with. Every member is given 2 Hatchlings to start their Mystveil journey with! As you play the game, your Hatchling will develop traits [known as Upgrades!] to make themselves unique, but also grow into adults. However first, every MYO must go through the approval process. This process starts with designing your MYO according to our MYO guide, then submitting it to the group for approval. Once approved, you're free to use your MYO in Mystveil!
                </p>
              </div>

              {/* What is a Veilkin */}
              <div className="mystical-card">
                <h2 className="mystical-subtitle text-black text-2xl mb-6">
                  What is a Veilkin?
                </h2>
                
                <p className="mystical-text text-black mb-6">
                  Here's the basics!
                </p>

                {/* Veilkin Guide Image */}
                <div className="w-full mb-8 rounded-xl overflow-hidden shadow-lg mystical-glow">
                  <img 
                    src="https://pbs.twimg.com/media/Ge2UXxrXQAA4Y28?format=jpg&name=4096x4096" 
                    alt="Veilkin Guide Banner" 
                    className="w-full h-auto block object-cover"
                  />
                </div>
                
                {/* Veilkin Types List */}
                <div className="mystical-card bg-purple-500 bg-opacity-10 mb-6">
                  <ul className="space-y-3">
                    <li className="mystical-text text-gray-800">
                      <span className="font-bold text-purple-600">Hatchling:</span> A Veilkin who is a minor. Veilkin of this growth stage are around the age of 0 to 17 years old in human years.
                    </li>
                    <li className="mystical-text text-gray-800">
                      <span className="font-bold text-purple-600">Veiled:</span> A Veilkin who is an adult. Veilkin of this growth stage are around the age of 18 to 70 years old in human years.
                    </li>
                    <li className="mystical-text text-gray-800">
                      <span className="font-bold text-purple-600">Elder:</span> A Veilkin who is an elder. Veilkin of this growth stage are always 70 or older years old in human years.
                    </li>
                    <li className="mystical-text text-gray-800">
                      <span className="font-bold text-purple-600">Veilkins:</span> A group of Veilkin.
                    </li>
                    <li className="mystical-text text-gray-800">
                      <span className="font-bold text-purple-600">Veilkin:</span> The name of the playable species in Mystveil!
                    </li>
                  </ul>
                </div>
                
                <p className="mystical-text text-black mb-4 leading-relaxed">
                  Within the ARPG you will be able to play as a Hatchling then once your Hatchling gains enough experience, they can become an adult. This is not reflective of the video game, which will have more growth stages before becoming an adult.
                </p>
                
                <p className="mystical-text text-black mb-4 leading-relaxed">
                  A Veilkin is a species of Dragon which evolved or lives in the area around Mystveil Township! All Veilkin live in Mystveil around the beginning of their lives, journeying to other isles or staying in Mystveil upon growing up. They are social dragons who lay eggs, and these eggs are cared for communally by the town of Mystveil through the Hatchery. Every Hatchling who lived in Mystveil once in their lives has spent their time in the Hatchery. Upon hatching, Hatchlings are very independent and curious about their world! They may be raised by their parents, or raised by Hatchery Keepers. However one thing is for sure, a Hatchling is never left without the love of a caretaker in Mystveil!
                </p>
              </div>

              {/* How to Join */}
              <div className="mystical-card">
                <h2 className="mystical-subtitle text-black text-2xl mb-6">
                  How do I join Mystveil?
                </h2>
                <p className="mystical-text text-black leading-relaxed">
                  Mystveil is currently open to those who are interested in joining!
                </p>
              </div>
            </div>
            
            {/* Navigation Buttons */}
            <div className="flex flex-wrap justify-center gap-4 mt-12">
              <Link to="/guide" className="mystical-button">
                Back to Guides
              </Link>
              <Link to="/guide/MYO" className="mystical-button">
                Create Your Veilkin
              </Link>
            </div>
          </div>
        </div>
      </main>

      {/* Mystical Footer */}
      <footer className="mystical-nav py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p className="mystical-text font-bold">
            © 2025 4fingerstudios <br /> 
            © 2024 Reckless Dreams. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default NewbieGuidePage;